export const RETAILER_APP_IDENTIFIER = "web-retailer";
